import {
    Arrangers,
    AuthorisedContacts,
    Cars,
    Certification,
    Conductors,
    Coordinators,
    Disposal,
    Hearse,
    Informant,
    MortuaryLocation,
    PlaceOfService,
    PlaceOfViewingItems,
    RefreshmentsVenue,
    RunsheetPDFs,
    SpecialInstructions,
    ValuableItems
} from '../FuneralFragments';
import { AllSuppliers } from '../../fragments/Bookings';
import { buildTabDataFragment } from '../../../util/functions';
import gql from 'graphql-tag';

export default buildTabDataFragment(
    [
        gql`
            fragment SummaryFields on Funeral {
                Created
                CreatedBy {
                    ID
                    FirstName
                    Surname
                }
                Office {
                    ID
                    BusinessName
                    Phone
                }

                DateOfService

                WebcastRequired
                WebcastConfirmed
                WebcastEmailedLinkToFamily
                WebcastComment

                AdminChecksComplete
                TransferActioned
                DoctorAttachedToFlag

                FirstName
                MiddleName
                Surname

                ApprovedByClient
                ApprovedOn
                RejectionNote
                RejectedOn
            }
        `,
        AllSuppliers,
        Arrangers,
        AuthorisedContacts,
        Cars,
        Certification,
        Conductors,
        Coordinators,
        Disposal,
        Hearse,
        Informant,
        MortuaryLocation,
        PlaceOfService,
        PlaceOfViewingItems,
        RefreshmentsVenue,
        RunsheetPDFs,
        SpecialInstructions,
        ValuableItems
    ],
    'Funeral'
);
